import styled, { css } from 'styled-components';

import { Item } from './HeaderMenu';

export const MenuWrapper = styled.nav`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const MenuRightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-left: 32px;
`;

export const MenuContainer = styled.div`
  display: flex;
  align-items: center;
  @media screen and (width < 768px) {
    display: none;
  }
`;

export const SubmenuWrapper = styled.ul`
  display: block;
  opacity: 0;
  pointer-events: none;
  transition: ease-in-out 100ms;
  position: absolute;
  bottom: 0;
  left: 0;
  transform: translateY(100%);
  list-style: none;
  background-color: var(--gray-01);
  min-width: 231px;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.16);
  padding: 32px;
  cursor: default;
`;

export const SubmenuItem = styled.li`
  font-size: 16px;
  line-height: 24px;
  width: 100%;
  cursor: pointer;
`;

export const MenuItem = styled.div<Pick<Item, 'selected' | 'hasSubmenu'>>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  position: relative;
  padding: 0 16px;
  height: 80px;
  margin-right: 16px;
  gap: 16px;
  cursor: pointer;
  text-wrap: nowrap;

  & .ds-icon {
    background-color: white !important;
  }

  & span {
    font-size: 16px;
    line-height: 24px;
    letter-spacing: -0.6px;
    font-weight: ${({ selected }) => (selected ? '700' : 'normal')};

    svg {
      display: inline-block;
      margin-left: 8px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 3px;
    width: 100%;
    background: ${({ selected }) => (selected ? 'var(--green-principal)' : 'initial')};
  }

  &:hover {
    &::before {
      background: var(--green-principal);
    }

    ${({ hasSubmenu }) =>
      hasSubmenu &&
      css`
        ${SubmenuWrapper} {
          opacity: 1;
          pointer-events: all;
        }
      `}
  }
`;

export const Icon = styled.img`
  margin-right: 12px;
`;
